import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { API_BASE_URL } from '../lib/api';
import { Field } from './Field';
import { buttonClass } from './ui/Button';

// Work-email SSO entry (#475): a NATIVE GET form to the enterprise
// (email-domain routed) leg — the browser navigates with `?email=…`, zero JS.
// Own file so the <form> is this template's ROOT — happy-dom loses
// `form.nextSibling`, so a form must never have template siblings (#481).
//
// Zero JS is also why the return target rides a HIDDEN INPUT: a native GET
// submit replaces the action's query string wholesale, so a `?return_to=` on
// the action would be dropped. Rendered only when there IS one — a blank input
// would submit `return_to=` (`lib/return-to.ts`).

export function SsoEmailForm(props: { returnTo?: string | null } = {}): JSX.Element {
  return (
    <form class="sso-login-form" method="get" action={`${API_BASE_URL}/auth/sso/login`}>
      <Field label={t('login.sso_email_label')} id="sso-email">
        {(a11y) => (
          <input
            {...a11y}
            class="input"
            name="email"
            type="email"
            required
            placeholder={t('login.sso_email_placeholder')}
            autocomplete="email"
          />
        )}
      </Field>
      <Show when={props.returnTo}>
        {(target) => <input type="hidden" name="return_to" value={target()} />}
      </Show>
      <button type="submit" class={buttonClass()}>
        {t('login.sso_email_cta')}
      </button>
    </form>
  );
}
